import React from 'react';
import { Link } from 'react-router-dom';
import i18next from 'i18next';

import EarthIcon from 'assets/map_toggle/earth.svg';
import ListIcon  from 'assets/map_toggle/list.svg';

import './i18n';
import styles from './styles.module.scss';

interface Props {
  listPath: string;
  label?: string;
  defaultChecked?: boolean;
  className?: string;
}

function MapToggle({ listPath, defaultChecked = true, className }: Props) {
  const isMapView = defaultChecked;

  return (
    <div className={className || (isMapView ? styles.toggleContainerMap : styles.toggleContainerList)}>
      <Link to={listPath} className={`${styles.toggleButton} ${!isMapView ? styles.listView : ''}`}>
        {isMapView ? (
          <>
            <img src={ListIcon} className={styles.icon} />
            <span className={styles.text}>{i18next.t('mapToggle:showList')}</span>
          </>
        ) : (
          <>
            <img src={EarthIcon} className={styles.icon} />
            <span className={styles.text}>{i18next.t('mapToggle:showMap')}</span>
          </>
        )}
      </Link>
    </div>
  );
}

export default MapToggle;
